import { useMutation } from 'react-query'
import { type MeetingPersistence } from '../../../../types/persistence/meeting-persistence'
import { api } from '../../../api'

export const createMeeting = async ({
  taskId,
  startAt,
  endAt,
  experts,
  analysts,
  administrativeUsers,
  summary,
  description,
  contacts
}: MeetingPersistence) => {
  const response = await api.post('/meetings', {
    taskId,
    summary,
    description,
    startAt,
    endAt,
    experts,
    analysts,
    administrativeUsers,
    contacts
  })

  return response.data
}

export const updateMeeting = async (id: number, {
  taskId,
  startAt,
  endAt,
  experts,
  analysts,
  administrativeUsers,
  summary,
  description,
  contacts
}: MeetingPersistence) => {
  const response = await api.put(`/meetings/${id}`, {
    taskId,
    summary,
    description,
    startAt,
    endAt,
    experts,
    analysts,
    administrativeUsers,
    contacts
  })

  return response.data
}

export const useCreateMeetingMutation = () => {
  return useMutation('@meeting/create', {
    mutationFn (data: MeetingPersistence) {
      return createMeeting(data)
    }
  })
}

export const useUpdateMeetingMutation = () => {
  return useMutation('@meeting/create', {
    mutationFn ({ id, data }: { id: number, data: MeetingPersistence }) {
      return updateMeeting(id, data)
    }
  })
}
